import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarRightShow20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSidebarRightShow20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.5 4.5h-2.51v11h2.51a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1m-13 0h8.99v11H3.5a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1m0-1.5A2.5 2.5 0 0 0 1 5.5v9A2.5 2.5 0 0 0 3.5 17h13a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 16.5 3zm5.556 5.055a.75.75 0 0 0-1.06-1.06L5.52 9.47l-.53.53.53.53 2.475 2.475a.75.75 0 0 0 1.06-1.06L7.112 10z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarRightShow20);
